// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';

export const useDebouncedValue = <T>(value: T, delay = 500): T => {
    const [debouncedValue, setDebouncedValue] = React.useState(value);

    React.useEffect(() => {
        const timeout = setTimeout(() => setDebouncedValue(value), delay);

        return () => clearTimeout(timeout);
    }, [value, delay]);

    return debouncedValue;
};
